import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  user: null,   
  role: null,
  isLoggedIn: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.user = null;
      state.role = null;
      state.isLoggedIn = false;
    }
  }
});

// Export actions
export const { setUser, logout } = authSlice.actions;

export const selectUser = (state) => state.auth.user;
export const selectRole = (state) => state.auth.role;
export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;

// Export reducer
export default authSlice.reducer;
